import { LandingHorizontalBlock } from 'src/components/landingComponents/containers/common';
import FirstBlock from './firstBlock';
import Instructions from './instruction';
import Result from './result';
import ServiceInfo from '../home/serviceInfo';
import styles from './howTo.module.scss';
import { useLayoutEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BreadcrumbSchema from 'src/components/breadcrumbs/schema';

const HowTo = () => {
  const [searchParams] = useSearchParams();

  useLayoutEffect(() => {
    if (searchParams.get('show') === 'instructions') {
      setTimeout(() => {
        const element = document.getElementById('instructions');
        const offset = (element?.offsetTop ?? 100) - 110;
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
        // element.scrollIntoView({
        //   behavior: 'smooth',
        //   block: 'start',
        //   top: offset,
        // });
      }, 100);
    }
  }, [searchParams]);

  return (
    <>
      <BreadcrumbSchema
        currentPage="howto"
        description="Инструкция как пользоваться системой Ламетри, в том числе: загрузка ПДФ, внесение жалоб и другой медицинской информации, получение, сохранение и повторное использование результатов."
      />
      <LandingHorizontalBlock className={styles.firstBlock}>
        <FirstBlock />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock id="instructions" className={styles.instructions}>
        <Instructions />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock className={styles.result}>
        <Result />
      </LandingHorizontalBlock>
      <LandingHorizontalBlock className={styles.serviceInfo}>
        <ServiceInfo />
      </LandingHorizontalBlock>
    </>
  );
};

export default HowTo;
